import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, Panel, ButtonGroup, Row, Col, Dropdown } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'

export default function TrackingHistoryLawResultTable({
  schema,
  dataKeyTable,
  pagination,
  onReload,
  loading,
  onSelect = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [tableData, setTableData] = useState([])
  const history = useHistory()

  // console.log('table schema ', schema)

  useEffect(() => {
    if (pagination && typeof onReload !== 'function') {
      setTableData(getData())
    } else if (schema.values) {
      setTableData(schema.values)
    } else {
      setTableData([])
    }
  }, [schema, pagination, onReload])

  const getData = () => {
    return schema?.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleChangePage = (dataKey) => {
    console.log('handleChangePage page ', dataKey)

    setPage(dataKey)
    if (typeof onReload === 'function') {
      // onReload(displayLength, dataKey)
      onReload(dataKey, displayLength)
    }
  }

  const handleChangeLength = (dataKey) => {
    console.log('handleChangeLength dataKey ', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1)
    }
  }

  return (
    <>
      <Panel
        header={schema.header || 'แสดงประวัติการบันทึกติดตามคดี'}
        collapsible
        defaultExpanded
        bordered
      >
        {/* {schema.exportButton && (
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: 'right' }}>
              <Dropdown
                title={schema.exportButton.label}
                appearance="primary"
                color="blue"
                icon={<Icon icon="file-text-o"></Icon>}
                placement="bottomEnd"
              >
                {schema.exportButton.options.map((item, index) => {
                  return <Dropdown.Item key={index}>{item.label}</Dropdown.Item>
                })}
              </Dropdown>
            </Col>
          </Row>
        )} */}

        <Table
          wordWrap
          minHeight={400}
          autoHeight
          loading={loading}
          data={tableData}
          style={{ marginTop: '20px' }}
        >
          <Column width={70} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return (page - 1) * displayLength + index + 1
              }}
            </Cell>
          </Column>

          <Column width={70} align="center">
            <HeaderCell>ครั้งที่</HeaderCell>
            <Cell dataKey="numberOfSequence" />
          </Column>

          <Column minWidth={220} width={220} flexGrow={1}>
            <HeaderCell>สถานะทางกฎหมาย</HeaderCell>
            <Cell dataKey="status" />
          </Column>

          <Column minWidth={220} idth={220} flexGrow={1}>
            <HeaderCell>สถานะย่อยทางกฎหมาย</HeaderCell>
            <Cell dataKey="subStatus" />
          </Column>

          <Column width={200}>
            <HeaderCell>วันที่ดำเนินการ</HeaderCell>
            <Cell dataKey="createDateStr" />
          </Column>

          <Column width={200}>
            <HeaderCell>ผู้ดำเนินการ</HeaderCell>
            <Cell dataKey="actionBy" />
          </Column>

          <Column width={200}>
            <HeaderCell>แก้ไขล่าสุด</HeaderCell>
            <Cell>
              {(rowData) => {
                return <>{rowData?.updateDateStr || rowData?.createDateStr || ''}</>
              }}
            </Cell>
          </Column>

          <Column width={95} align="center" fixed="right">
            <HeaderCell></HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <IconButton
                      color="blue"
                      appearance="primary"
                      icon={<Icon icon="eye" />}
                      onClick={() => {
                        onSelect(rowData)
                      }}
                      size="sm"
                    >
                      แสดง
                    </IconButton>
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>

        {pagination && (
          <TablePagination
            lengthMenu={defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={schema?.totalSize || 0}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        )}
      </Panel>
    </>
  )
}
